import {
  Categories,
 
  Services as ServicesList,
  
} from "../components/services";
import About from "../components/services/About";

const Services = () => {
  return (
    <div className="pt-20 max-w-7xl mx-auto px-4">
      <About/>
      <ServicesList />
      <Categories />
      {/* <Counter />
      <Team />
      <Feeds /> */}
    </div>
  );
};

export default Services;
